import React from "react";
import styles from "../TileViewTable.module.scss";
import TNButton from "../../../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonSize,
  CommonButtonTexts,
} from "../../../../enums/ButtonAttributesEnums";
import { getViewCardrenderData } from "../constants";
import clsx from "clsx";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import DescriptionCell from "../../../../reusable-components/DescriptionCell";

export interface TileViewCardProps {
  record?: any;
  onTileClick?: (startDate: string, endDate: string) => void;
  onDownloadClick: (record: any) => void;
  editAccess: boolean;
}

const TileViewCard = ({
  record,
  onTileClick,
  onDownloadClick,
  editAccess,
}: TileViewCardProps) => {
  return (
    <div
      className={styles.viewCard}
      onClick={() => {
        if (!!!record?.meta?.customers) return;
        onTileClick?.(record?.startDate, record?.endDate);
      }}
    >
      <div className={styles.viewCardHeader}>
        <div className={styles.dateRangeCell}>
          {record?.startDate} - {record?.endDate}
        </div>
        <ConditionalRender visible={!!record?.meta?.customers}>
          <TNButton
            className={styles.downloadButton}
            size={ButtonSize.MEDIUM}
            onClick={(event) => {
              event.stopPropagation();
              onDownloadClick(record);
            }}
            text={CommonButtonTexts.DOWNLOAD}
            shape={ButtonShape.DEFAULT}
            disabled={!editAccess}
          />
        </ConditionalRender>
      </div>
      <div className={styles.dataWrapper}>
        {getViewCardrenderData(record)?.map((col, index) => {
          if (index === 0) {
            return (
              <div key={`overview-${index}`} className={styles.overviewData}>
                <div className={styles.labelColumn}>
                  {col?.values?.[0]?.map((item, itemIndex) => (
                    <div
                      key={`label-${itemIndex}`}
                      className={styles.singleCell}
                    >
                      {item}
                    </div>
                  ))}
                </div>
                <div className={styles.countColumn}>
                  {col?.values?.[1]?.map((item, itemIndex) => (
                    <div
                      key={`count-${itemIndex}`}
                      className={styles.singleCell}
                    >
                      {item}
                    </div>
                  ))}
                </div>
                <div className={styles.topColumn}>
                  {col?.values?.[2]?.map((item, itemIndex) => (
                    <div
                      key={`top-${itemIndex}`}
                      className={clsx(styles.singleCell, styles.topCell)}
                    >
                      <span className={styles.labelTop}>{"Top: "}</span>
                      <DescriptionCell text={item} />
                    </div>
                  ))}
                </div>
              </div>
            );
          } else {
            return (
              <div key={`data-${index}`} className={styles.dataColumn}>
                <div
                  className={clsx(styles.labelsCol, {
                    [styles.longerCol]: index === 3,
                  })}
                >
                  {col?.label?.map((text, idx) => (
                    <span
                      key={`label-${idx}`}
                      className={clsx({ [styles.topRow]: idx === 0 })}
                    >
                      {text}
                    </span>
                  ))}
                </div>
                <div className={styles.valuesCol}>
                  {col?.dataVal?.map((val, idx) => (
                    <span
                      key={`value-${idx}`}
                      className={clsx({ [styles.topRow]: idx === 0 })}
                    >
                      {val}
                    </span>
                  ))}
                </div>
                <div className={styles.percentageCol}>
                  {col?.dataPercentage?.map((val, idx) => (
                    <span key={`percentage-${idx}`}>
                      {`${val}${val ? "%" : ""}`}
                    </span>
                  ))}
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default TileViewCard;
